import React, { useCallback, useEffect } from "react";
import Form from "../../controllers/abmSintetico/Form";


export const FileProperties = (props) => {

  const { lateralForm, id } = props;

  const handleOnChangeConfirm = useCallback(() => {
    console.log("handleOnChangeConfirm");
  }, []);

  useEffect(()=>{
    console.log("props change on fileproperties", props)
  }, [props])
  

  return <Form devMode={true} {...props} onChangeConfirm={handleOnChangeConfirm} action={id === 0 ? "add" : "edit"} id={id}/>

}

